// extracted by mini-css-extract-plugin
export default {"workspaceContainer":"PieceEditBody_workspaceContainer__V4fP1"};